import React from "react";
import { SEO, MainLayout, OrderDetails } from "../../../components";

const OrderDetailsPage = () => {
  return (
    <>
      <SEO title="order details" />
      <MainLayout>
        <OrderDetails />
      </MainLayout>
    </>
  );
};

export default OrderDetailsPage;
